import { useEffect, useState } from 'react'

import useStore from '@/store/useStore'
import { EventType } from '@/types/servicesTypes/configTypes'

export const useRedeemablePPVEvent = (event?: Nullable<EventType>) => {
  const userCreditsWallets = useStore(
    (state) => state.common.userCreditsWallets,
  )
  const [isRedeemablePPVEvent, setIsRedeemablePPVEvent] = useState<boolean>()

  useEffect(() => {
    if (!event?.ppvInfo || !userCreditsWallets?.length) {
      return setIsRedeemablePPVEvent(false)
    }
    const hasSameCreditsWallet = event.ppvInfo.some((ppvWallet) =>
      userCreditsWallets.find(
        (creditWallet) => creditWallet.uniqueId === ppvWallet.walletId,
      ),
    )

    setIsRedeemablePPVEvent(hasSameCreditsWallet)
  }, [event?.ppvInfo, userCreditsWallets])

  return isRedeemablePPVEvent
}
